module.exports = __webpack_public_path__ + "static/media/introduction-01.5cd2a2bd.png";